<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 184.6 151.2"
    xml:space="preserve"
  >
    <path
      fill="#d8c5b4"
      d="M180.9,113.6c-2,9-7,14-13,14s-11-3-11-3s-1,12-12,17s-35,6-41,5s-9-7-9-7s-3,7-7,7s-6-8-6-8s-3,7-9,6
	s-1-43-1-43c-4.4-2.1-12.3-6.7-18.1-15.6c-1.2-1.8-3.4-5.4-4.8-10.5c-0.2-0.7-0.4-1.3-0.5-2c-0.6-2.9-0.8-5.4-0.8-7.4
	c0-2.2,0.2-3.8,0.3-4.3c0.4-3,1.1-7.8,4.6-12.2c4.9-6.4,12.2-7.8,14.5-8.2c-2.5-20.2-2.8-33.4,2-36.8c2.1-1.4,4.7-0.4,5.1-0.2
	c4.3,4.3,5.9,16.7,10.2,36.8c0.8,3.6,0.7,2.3,6.4,3.1c9.2-2.8,28-15.6,44.4-17.4c13.7-1.4,16.9,4.4,15.1,8.2
	c-3,6-23.7,13.2-47.2,18.1c0.6,3.5,3.6,6.9,4.6,13.3c0.4,2.8,0,5.4,4.2,6.3c4.4,0.9,20.7,1.2,34,14c8,7.7,11.5,16.3,13,21
	c0,0,13-10,17-8S182.9,104.6,180.9,113.6z"
    />
    <ellipse
      transform="matrix(0.5 -0.866 0.866 0.5 -20.6534 116.2637)"
      fill="#f69a9f"
      cx="90.4"
      cy="76"
      rx="5.7"
      ry="6.7"
    />
    <path
      fill="#f69a9f"
      d="M52.4,75c-1.1,0.5-2.3,0.6-3.4,0.5c-0.2-0.7-0.4-1.3-0.5-2c-0.6-2.9-0.8-5.4-0.8-7.4c0.2-0.1,0.4-0.2,0.5-0.3
	c3-1.3,6.4-0.2,7.5,2.3C56.9,70.7,55.4,73.8,52.4,75z"
    />
    <path
      fill="#f69a9f"
      d="M97.9,50.6c0,0,6.5-8.6,23-14.9s19.1-8.1,21.6-2.3s-8.2,7.7-14.3,9.5C119.5,45.4,110.6,48.1,97.9,50.6z"
    />
    <g>
      <circle
        cx="84.8"
        cy="63.3"
        r="3.8"
      />
      <circle
        fill="#ffffff"
        cx="83.6"
        cy="62.2"
        r="1.4"
      />
    </g>
    <g>
      <circle
        cx="61.3"
        cy="59.1"
        r="3.6"
      />
      <circle
        fill="#ffffff"
        cx="60.7"
        cy="58.2"
        r="1.3"
      />
    </g>
    <path
      fill="none"
      stroke="#020202"
      stroke-width="2"
      stroke-miterlimit="10"
      d="M80.6,77.5c0,0-2.1,3.6-5.5,2.6c-3.4-1.1-4.4-8-4.4-8c-0.5,1.3-2.2,4.4-3.4,5.4c-1.7,1.4-4.9,0.9-7.4-1.8"
    />
    <path
      fill="#f69a9f"
      d="M72,62.5c0,0-0.3-1.1-2.3-1.4c-2.5-0.4-3,2.3-1.5,4.3c1.4,1.9,2.8,2.9,2.8,2.9s5.5-1.5,5.4-5
	C76.3,60.7,73.1,60.9,72,62.5z"
    />
    <g display="none">
      <path
        display="inline"
        fill="#66260f"
        d="M0,71.7v70c0,0,3,8,17,8s16-6,16-6l2-71c0,0-3-8-17-8S0,71.7,0,71.7z"
      />
      <ellipse
        display="inline"
        fill="#c75b28"
        cx="17.5"
        cy="71.7"
        rx="17.5"
        ry="8"
      />
      <circle
        display="inline"
        fill="#faa723"
        cx="9.5"
        cy="72.2"
        r="4.5"
      />
      <ellipse
        display="inline"
        fill="#fbbd21"
        cx="18.5"
        cy="74.2"
        rx="4.5"
        ry="3.5"
      />
      <ellipse
        display="inline"
        fill="#faa723"
        cx="26.5"
        cy="71.2"
        rx="5.5"
        ry="4.5"
      />
      <ellipse
        display="inline"
        fill="#fbbd21"
        cx="24.5"
        cy="65.2"
        rx="4.5"
        ry="3.5"
      />
      <ellipse
        transform="matrix(0.6513 -0.7588 0.7588 0.6513 -46.1229 35.2174)"
        display="inline"
        fill="#fbbd21"
        cx="15.3"
        cy="67.8"
        rx="3.5"
        ry="4.5"
      />
      <ellipse
        display="inline"
        fill="#cb3727"
        cx="19.5"
        cy="64.2"
        rx="4.5"
        ry="4.5"
      />
    </g>
    <path
      fill="none"
      stroke="#9b8c81"
      stroke-miterlimit="10"
      d="M136.7,97.9c0,0-14.7,0-21,13s-1.1,26-1.1,26s-17.9-8-18.9,1s15.8,8.8,15.8,8.8"
    />
    <path
      fill="none"
      stroke="#9b8c81"
      stroke-miterlimit="10"
      d="M95.5,137.6c0,0-0.9,9.6-8.3,9s-6.5-43-6.5-43l1.5,34.3c0,0-3.3,7.7-8.9,6.7s-0.9-43-0.9-43"
    />
    <g>
      <path
        fill="#fff8e2"
        d="M59.7,109.5c0.4,1.2,0.7,2.3,1,3.4c0.1,0.3,0.1,0.5,0.2,0.8c0.5,2.3,0.8,4.4,0.9,6.5c0,0.2,0,0.4,0,0.7
		c0,0.5,0,1.1,0,1.6c0,0.4,0,0.8-0.1,1.1c0,0.7-0.1,1.3-0.2,2c-0.1,0.7-0.2,1.3-0.4,2c-0.3,1.2-0.6,2.3-1,3.3
		c-2.5,6.7-7.9,11.4-14.4,13.6c-6.5,2.2-13.6,1.6-19.8-2.3c-0.9-0.5-1.7-1.2-2.5-1.8c-0.5-0.4-1-0.9-1.5-1.4
		c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.6-1.2-1.3-1.8-2.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.3-0.4-0.5-0.6-0.8c-1.4-1.9-2.6-4.1-3.7-6.6
		c-0.1-0.2-0.2-0.4-0.3-0.7c-0.4-1-0.9-2.1-1.2-3.3c-0.2-0.6-0.4-1.2-0.6-1.8v-0.1c-0.1-0.3-0.2-0.5-0.2-0.8
		c-0.1-0.2-0.1-0.4-0.2-0.7c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.5-0.3-1.1-0.4-1.6c0-0.1,0-0.1,0-0.2c-0.1-0.6-0.3-1.1-0.4-1.6
		c-0.1-0.3-0.1-0.6-0.2-0.9c-0.2-1-0.4-1.9-0.5-2.9c-0.3-1.8-0.5-3.5-0.6-5.2c-0.1-0.7-0.1-1.3-0.1-2c-0.1-2.8,0-5.5,0.2-8
		c0.1-1,0.3-2,0.4-3c0.2-0.9,0.4-1.8,0.6-2.7c1.9-7.5,6-13.1,12.1-15.1s12.6,0.1,18.6,5c0.7,0.6,1.4,1.2,2.1,1.8
		c0.8,0.8,1.7,1.6,2.5,2.5c1.6,1.8,3.2,3.8,4.6,6c0.4,0.5,0.7,1.1,1.1,1.7c0.9,1.4,1.7,2.8,2.5,4.3c0.4,0.8,0.9,1.7,1.3,2.5
		c0.2,0.4,0.3,0.7,0.5,1.1c0.2,0.5,0.5,1,0.7,1.5c0,0.1,0.1,0.1,0.1,0.2c0.2,0.5,0.4,1,0.7,1.5c0.1,0.1,0.1,0.3,0.2,0.4
		c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.3,0.2,0.5,0.3,0.8c0,0.1,0,0.1,0.1,0.2C59.3,108.4,59.5,108.9,59.7,109.5z"
      />
      <g>
        <path
          fill="#fbb962"
          d="M58.4,106.2l-45.8,15.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.5-0.3-1.1-0.4-1.6c0-0.1,0-0.1,0-0.2l45.5-15
			c0,0.1,0.1,0.1,0.1,0.2c0.2,0.5,0.4,1,0.7,1.5C58.3,105.9,58.4,106.1,58.4,106.2z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#ee6b97"
            d="M61.8,120.2c0,0.2,0,0.4,0,0.7c0,0.5,0,1.1,0,1.6c0,0.4,0,0.8-0.1,1.1c-0.3-0.3-0.5-0.5-0.8-0.8
				c-1.8-2-3.1-3.3-4.4-2.9c-1.3,0.4-1.5,2.2-1.8,4.9c-0.3,2.8-0.6,6-3.4,6.9c-2.8,0.9-4.9-1.5-6.9-3.6c-1.8-2-3.1-3.3-4.4-2.9
				c-1.2,0.4-1.5,2.2-1.8,4.9c-0.3,2.8-0.6,6-3.4,6.9c-2.8,0.9-4.9-1.5-6.9-3.6c-1.8-2-3.1-3.3-4.4-2.9c-1.2,0.4-1.5,2.2-1.8,4.9
				c-0.1,0.9-0.2,1.8-0.4,2.7c-0.6-0.6-1.2-1.3-1.8-2.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.2,0-0.4,0.1-0.6c0.3-2.8,0.6-6,3.4-6.9
				c2.8-0.9,4.9,1.5,6.9,3.6c1.8,2,3.1,3.3,4.4,2.9c1.3-0.4,1.5-2.2,1.8-4.9c0.3-2.8,0.6-6,3.4-6.9c2.8-0.9,4.9,1.5,6.9,3.6
				c1.8,2,3.1,3.3,4.4,2.9c1.3-0.4,1.5-2.2,1.8-4.9c0.3-2.8,0.6-6,3.4-6.9C58.2,116.8,60.2,118.4,61.8,120.2z"
          />
        </g>
        <g>
          <ellipse
            transform="matrix(0.9498 -0.3128 0.3128 0.9498 -41.1147 14.7091)"
            fill="#ee6b97"
            cx="25.3"
            cy="135.5"
            rx="1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            transform="matrix(0.9498 -0.3128 0.3128 0.9498 -38.5945 19.6011)"
            fill="#ee6b97"
            cx="41.8"
            cy="130.1"
            rx="1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            transform="matrix(0.9498 -0.3128 0.3128 0.9498 -36.0889 24.465)"
            fill="#ee6b97"
            cx="58.2"
            cy="124.7"
            rx="1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            transform="matrix(0.9498 -0.3128 0.3128 0.9498 -39.1323 16.6761)"
            fill="#ee6b97"
            cx="32.4"
            cy="130.3"
            rx="1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            transform="matrix(0.9498 -0.3128 0.3128 0.9498 -36.5399 21.6439)"
            fill="#ee6b97"
            cx="49.2"
            cy="124.7"
            rx="1"
            ry="1.1"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#ee6b97"
            d="M46.7,87.1c-0.5-0.3-1.1-0.4-1.6-0.2c-1.3,0.4-1.6,2.3-1.9,5.1c-0.3,2.9-0.7,6.2-3.5,7.1
				c-2.9,0.9-5.1-1.5-7.1-3.7c-1.9-2.1-3.2-3.4-4.5-3s-1.6,2.3-1.9,5.1c-0.3,2.9-0.7,6.2-3.5,7.1c-2.9,0.9-5.1-1.5-7.1-3.6
				c-1.9-2.1-3.2-3.4-4.5-3c-0.3,0.1-0.5,0.3-0.7,0.5c0.1-1,0.3-2,0.4-3c2.6-0.5,4.7,1.8,6.6,3.8c1.9,2.1,3.2,3.4,4.5,3
				s1.6-2.3,1.9-5.1c0.3-2.9,0.6-6.2,3.5-7.1s5.1,1.5,7.1,3.7c1.9,2.1,3.2,3.4,4.5,3s1.6-2.3,1.9-5.1c0.3-2.9,0.6-6.1,3.4-7.1
				C45.1,85.3,45.9,86.2,46.7,87.1z"
          />
        </g>
        <g>
          <ellipse
            fill="#ee6b97"
            cx="12.9"
            cy="102.9"
            rx="1.1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            fill="#ee6b97"
            cx="29.8"
            cy="97.3"
            rx="1.1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            fill="#ee6b97"
            cx="46.8"
            cy="91.8"
            rx="1.1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            fill="#ee6b97"
            cx="20.2"
            cy="97.5"
            rx="1.1"
            ry="1.1"
          />
        </g>
        <g>
          <ellipse
            fill="#ee6b97"
            cx="37.5"
            cy="91.8"
            rx="1.1"
            ry="1.1"
          />
        </g>
      </g>
      <path
        fill="#7ecfda"
        d="M60.3,130.9c-2.5,6.7-7.9,11.4-14.4,13.6c-6.5,2.2-13.6,1.6-19.8-2.3L60.3,130.9z"
      />
      <path
        fill="#7ecfda"
        d="M42.2,82.7L11.6,92.8c1.9-7.5,6-13.1,12.1-15.1C29.8,75.7,36.2,77.8,42.2,82.7z"
      />
      <path
        fill="#85c565"
        d="M56.8,102.6l-2.2,0.7c-3.2,1-6.6-0.6-7.9-3.6c0.7,3.3-1.1,6.6-4.2,7.6l-2.3,0.7c-3,1-6.3-0.4-7.8-3.3
		c0.5,3.1-1.3,6.2-4.3,7.2l-2.3,0.7c-3.2,1-6.6-0.6-7.9-3.6c0.7,3.3-1.1,6.6-4.2,7.6l-2,0.7c-0.1-0.3-0.1-0.6-0.2-0.9
		c-0.2-1-0.4-1.9-0.5-2.9c0.4,0.5,0.7,1,1,1.5c-0.7-3.2,1.1-6.5,4.2-7.6l2.3-0.7c3.1-1,6.5,0.5,7.9,3.6c-0.7-3.2,1.1-6.5,4.2-7.6
		l2.2-0.7c3.2-1,6.5,0.5,7.9,3.6c-0.7-3.2,1.1-6.5,4.2-7.6l2.3-0.7c3.1-1,6.5,0.5,7.9,3.6c-0.1-0.7-0.2-1.4-0.1-2.1
		c0.4,0.8,0.9,1.7,1.3,2.5C56.5,101.9,56.6,102.2,56.8,102.6z"
      />
      <path
        fill="#85c565"
        d="M59.7,109.5c0.4,1.2,0.7,2.3,1,3.4c0.1,0.3,0.1,0.5,0.2,0.8c-1.9-0.4-3.6-1.7-4.4-3.5c0.7,3-1,6.1-3.9,7.1
		l-2.1,0.7c-2.8,0.9-5.9-0.4-7.2-3c0.5,2.9-1.2,5.8-4,6.7l-2.1,0.7c-2.9,1-6.1-0.5-7.4-3.3c0.7,3-1,6.1-3.9,7.1l-2.1,0.7
		c-2.9,1-6.1-0.5-7.4-3.3c0.4,1.9-0.1,3.8-1.3,5.2c-0.1-0.2-0.2-0.4-0.3-0.7c-0.4-1-0.9-2.1-1.2-3.3c-0.2-0.6-0.4-1.2-0.6-1.8
		c0.5-0.4,1.1-0.7,1.7-0.9l2.1-0.7c2.9-1,6.1,0.5,7.4,3.3c-0.6-3,1-6.1,3.9-7.1l2.1-0.7c2.9-1,6.1,0.5,7.4,3.3c-0.6-3,1-6.1,3.9-7.1
		l2-0.7c2.9-1,6.1,0.5,7.4,3.3c-0.7-3,1-6.1,3.9-7.1l2.1-0.7c0.7-0.2,1.4-0.3,2.1-0.3C59.3,108.4,59.5,108.9,59.7,109.5z"
      />
    </g>
    <path
      fill="#ee6b97"
      d="M79.1,126c-1.3,16.2-13.1,22.6-24.6,20.7s-20.7-11.5-17.1-27.5c3.6-16,14.1-27.8,25.6-25.9
	S80.5,109.6,79.1,126z"
    />
    <path
      fill="#ffffff"
      d="M55.8,107.9c-1.6,2.8-4.3,2.9-6.2,1.6s-2.7-3.9-0.7-6.4c2-2.6,5-3.8,6.9-2.4S57.4,105,55.8,107.9z"
    />
  </svg>
</template>
